import script from "./Home.vue?vue&type=script&lang=ts&setup=true"
export * from "./Home.vue?vue&type=script&lang=ts&setup=true"

import "./Home.vue?vue&type=style&index=0&id=73c287f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c287f0"]])

export default __exports__